module.exports = __webpack_public_path__ + "static/media/running.b0e3f776.gif";